import Vue from 'vue'
import vuex from '../store/index'
import VueRouter from 'vue-router'
import LoginUser from '@/components/Auth/LoginUser.vue'
import Categorias from '../components/Categorias/Categorias.vue'
import Clientes from '../components/Personas/Clientes.vue'
import Productos from '../components/Productos/Productos.vue'
//import Almacen from '../components/Almacen.vue'

import Usuarios from '../components/Usuarios/Usuarios.vue'
import Ventas from '../components/Ventas/Ventas.vue'
import Compras from '../components/Compras/ListarCompras.vue'
import ComprasFacturas from '../components/Compras/FacturaCompra.vue'
import POS from '../components/Ventas/PuntodeVenta.vue'
import Facturacion from '../components/Ventas/Facturacion.vue'
//import Facturacion from '../components/Facturacion/Facturacion.vue'
import UsuarioPermisos from '../components/UsuarioPermisos/UsuarioPermisos.vue'
import Profile from '../components/UsuarioPerfil.vue'
import Establecimientos from '@/components/Establecimientos/establecimiento.vue'
//import Reportes from '@/views/Reportes.vue'
import Reportes from '@/components/Reportes.vue'

/** MOBILE */
import Almacen from '../components/Productos/mobile/listar.vue'
import ArticuloNuevo from '../components/Productos/mobile/nuevo.vue'

Vue.use(VueRouter)
const router = new VueRouter({ 
  mode: 'history',
  routes : [
    {
      path: '*',
      redirect:'/login'
    },
  {
    path: '/',
    redirect:'/login'
  },
  {
    path: '/login',
    name: 'login',
    component:LoginUser
  },
  {
    path: '/categorias',
    name: 'Categorias',
    component:Categorias,
    meta:{autenticado:true},   
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/almacen',
    name: 'Almacen',
    component:Almacen,
    meta:{autenticado:true}, 
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/almacen/nuevo',
    name: 'articulonuevo',
    component:ArticuloNuevo,
    meta:{autenticado:true}, 
  },
  {
    path: '/productos',
    name: 'Productos',
    component:Productos,
    meta:{autenticado:true},   
  },
  {
    path: '/ventas',
    name: 'Ventas',
    component:Ventas,
    meta:{autenticado:true},   
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component:Clientes,
    meta:{autenticado:true},   
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component:Usuarios,
    meta:{autenticado:true},   
  },
  {
    path: '/puntodeventa',
    name: 'Puntodeventa',
    component:POS,
    meta:{autenticado:true},   
  },
  {
    path: '/facturacion',
    name: 'Facturacion',
    component:Facturacion,
    meta:{autenticado:true},   
  },
  {
    path: '/permisos',
    name: 'UsuarioPermisos',
    component:UsuarioPermisos,
    meta:{autenticado:true},   
  },
  {
    path: '/user/profile',
    name: 'Profile',
    component:Profile,
    meta:{autenticado:true},   
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component:Reportes,
    meta:{autenticado:true},   
  },
  {
    path: '/compras',
    name: 'Compras',
    component:Compras,
    meta:{autenticado:true},   
  },
  {
    path: '/compras/nueva',
    name:'facturascompras',
    component:ComprasFacturas,
    meta:{autenticado:true},  
  },
  {
    path: '/establecimientos',
    name: 'Establecimientos',
    component:Establecimientos,
    meta:{autenticado:true},   
  }
],

})


router.beforeEach((to, from, next) => {
  //Obtenemos la autenticacion del getter
  let autenticado = vuex.getters.getAutenticado
  //Verificamos que la ruta este protegida
  let autorizacion = to.matched.some(record=> record.meta.autenticado)
  //Si tiene autorizacion per no esta autenticado lo enviamos a login
  if(!autenticado && autorizacion){
    next({ path: '/login' })
    //Si esta autenticado pero no tiene accesso a esa ruta lo regresamos a productos
  }else if(autenticado && !autorizacion){ 
    next({ path: '/productos' })
  }else{
    next()
  }
  
})

export default router
